export function GeneralFooter() {
  return (
    <footer className="w-full container mx-auto">
      <div className=" flex flex-col items-center px-6 md:px-12 lg:px-6 xl:px-0 py-4">
        <span className="text-sm opacity-55">By Green4Digital</span>
      </div>
    </footer>
  );
}
